import React from 'react';
import TextField from "@material-ui/core/TextField";
//@ts-ignore
import InCardTextFieldWrapper from '../components/primitives/TextField/InCardTextFieldWrapper';

interface Props {
    input: string;
    submit: () => void;
    change: () => void;
    disabled: boolean;
}
const FilterInput = (props: Props) => {
    const { input, submit, change, disabled } = props;
    return (
      <InCardTextFieldWrapper>
          <form noValidate onSubmit={submit}>
              <TextField
                fullWidth
                placeholder={!disabled ? "Filter by name.." : "In Development"}
                value={`${input}`}
                onChange={change}
                disabled={disabled}
              />
          </form>
      </InCardTextFieldWrapper>
    );
};

export default FilterInput;